import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import { formatCount, formatRelativeDate } from "@/lib/format";

interface VideoCardProps {
  video: VideoItem;
  showCategory?: boolean;
}

export default function VideoCard({ video, showCategory = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 快手短视频`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <span className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center text-primary-600 text-2xl">
            <i className="ri-play-fill"></i>
          </span>
        </div>
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-950/75 text-background-50 text-xs">
          {video.duration}
        </span>
        {showCategory && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
            {video.categoryName}
          </span>
        )}
      </div>

      <div className="p-3 flex flex-col gap-2 flex-1">
        <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 mt-auto">
          <span className="w-6 h-6 rounded-full overflow-hidden bg-background-200 shrink-0">
            <img
              src={video.authorAvatar}
              alt={video.author}
              className="w-full h-full object-cover object-top"
            />
          </span>
          <span className="text-xs text-foreground-600 line-clamp-1">{video.author}</span>
          <span className="ml-auto flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-play-circle-line"></i>
            {formatCount(video.views)}
          </span>
        </div>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-thumb-up-line"></i>
            {formatCount(video.likes)}
          </span>
          <span>{formatRelativeDate(video.publishDate)}</span>
        </div>
      </div>
    </Link>
  );
}